import { ItemRoute } from './types'
import Kardex from '../../pages/Kardex'
import InventoryReport from '../../pages/InventoryReport'
import InventoryTransitReport from '../../pages/InventoryTransitReport'
import InventoryBook from '../../pages/InventoryBook'

import ShippingCostReport from '../../pages/ShippingCostReport'

const Reports: ItemRoute[] = [
    {
        cu: 'CU164',
        label: 'Kardex',
        title: 'Kardex',
        path: '/kardex',
        Component: Kardex
    },
    {
        cu: 'CU106',
        title: 'Reporte de Inventario',
        label: 'Reporte de Inventario',
        path: '/inventory_report',
        Component: InventoryReport
    },
    {
        cu: 'CU106',
        title: 'Reporte de Inventario en tránsito',
        label: 'Reporte de Inventario en tránsito',
        path: '/inventory_report_transit',
        Component: InventoryTransitReport
    },
    {
        cu: 'CU106',
        title: 'Libro de Inventario',
        label: 'Libro de Inventario',
        path: '/inventory_book',
        Component: InventoryBook
    },
    {
        cu: 'CU106',
        title: 'Reporte de Costos por Embarque',
        label: 'Reporte de Costos por Embarque',
        path: '/shipping_cost_report',
        Component: ShippingCostReport
    }
]

export default Reports
